import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import TrackingPage from '../pages/tracking/page';
import TrackingUpdatePage from '../pages/tracking-update/page';
import AboutPage from '../pages/about/page';
import AdminPage from '../pages/admin/page';
import AdminLoginPage from '../pages/admin/login/page';
import ContactPage from '../pages/contact/page';
import ServicesPage from '../pages/services/page';
import DashboardPage from '../pages/dashboard/page';
import LiveMapPage from '../pages/live-map/page';
import RouteOptimizationPage from '../pages/route-optimization/page';
import PrivacyPolicyPage from '../pages/legal/PrivacyPolicyPage';
import TermsOfServicePage from '../pages/legal/TermsOfServicePage';
import CookiePolicyPage from '../pages/legal/CookiePolicyPage';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/track', element: <TrackingPage /> },
  { path: '/track/:id', element: <TrackingUpdatePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/dashboard', element: <DashboardPage /> },
  { path: '/live-map', element: <LiveMapPage /> },
  { path: '/route-optimization', element: <RouteOptimizationPage /> },
  { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
  { path: '/terms-of-service', element: <TermsOfServicePage /> },
  { path: '/cookie-policy', element: <CookiePolicyPage /> },
  { path: '/admin/login', element: <AdminLoginPage /> },
  { path: '/admin', element: <AdminPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
